import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.7002 2.16602H7.30019C4.16686 2.16602 3.92519 4.98268 5.61686 6.51602L14.3835 14.4827C16.0752 16.016 15.8335 18.8327 12.7002 18.8327H7.30019C4.16686 18.8327 3.92519 16.016 5.61686 14.4827L14.3835 6.51602C16.0752 4.98268 15.8335 2.16602 12.7002 2.16602Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }